/**
 * RESPONSIBILITY: the picture a YouTube link already has.
 *
 * ONE derivation, in one place. The video id is read from every shape YouTube hands out
 * — watch links, short links, embeds, live — because a link pasted from a phone is not
 * the link pasted from a browser, and an editor should never have to know that.
 *
 * `maxres` is the 1280×720 still, which is what the page wants and what most videos
 * have; `hq` always exists and is the fallback when it does not. The caller asks for
 * both because only the browser can find out which one is really there.
 */
const PATTERNS = [
  /[?&]v=([A-Za-z0-9_-]{11})/,          // watch?v=
  /youtu\.be\/([A-Za-z0-9_-]{11})/,     // short link
  /\/embed\/([A-Za-z0-9_-]{11})/,       // iframe src
  /\/shorts\/([A-Za-z0-9_-]{11})/,      // shorts
  /\/live\/([A-Za-z0-9_-]{11})/,        // live
];

export function youtubeId(url: string | undefined): string {
  for (const re of PATTERNS) {
    const m = re.exec(url ?? '');
    if (m) return m[1];
  }
  return '';
}

/** Highest quality first. Empty when the link is not a YouTube one. */
export function youtubeThumbs(url: string | undefined): string[] {
  const id = youtubeId(url);
  if (!id) return [];
  return [
    `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`,
    `https://i.ytimg.com/vi/${id}/hqdefault.jpg`,
  ];
}
